import { useMutation } from '@tanstack/react-query';
import { paths } from '@/generated/supplier-experience-api';
import apiClient from '@/lib/apiClient';
import queryClient from '@/lib/queryClient';

type BuyerLendingRequestBody = paths['/buyers/lending']['post']['requestBody']['content']['application/json'];

const useCreateBuyerLendingRequest = () => {
  return useMutation({
    mutationKey: ['createBuyerLendingRequest'],
    mutationFn: (buyerLendingRequest: BuyerLendingRequestBody) => {
      return apiClient.post(`api/supplier-experience/buyers/lending`, {
        json: buyerLendingRequest,
      });
    },
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: ['buyerLendingRequests'],
      });
    },
  });
};

export default useCreateBuyerLendingRequest;
